import { DOCUMENT, LocationStrategy } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginType } from 'common/models/common/enums';
import { ADPConfigService } from 'digital-core';

// @dynamic
@Injectable({
  providedIn: 'root',
})
export class ConfigService extends ADPConfigService {
  declare public _config: any;

  constructor(
    private location: LocationStrategy,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ) {
    super();
    const window = this.getWindow();

    if (window["config"]) {
      this._config = window["config"];
    }
  }


  getWindow(): any {
    return window;
  }

  get aulUrl() {
    return this._config.aul.aulUrl;
  }

  get ACC_SSO_GroupName() {
    return this._config.preneed.acc_SSO_GroupName;
  }

  get FE_SSO_GroupName() {
    return this._config.preneed.fe_SSO_GroupName;
  }
  get aulApplicationName() {
    return this._config.aul.aulApplicationName;
  }

  get aulClient() {
    return this._config.aul.aulClient;
  }

  get resourceEditMode() {

    return this._config.sitefinitySettings.resourceEditMode;
  }
  get clientId() {
    return this._config.core.clientId;
  }

   get getThemeName(): string {
    return this._config?.core?.clientTheme;
  }


  // end-point config of Okta Token for D2C.
  oktaAuthEndPoint() {
    return `${this._config.site.apiUrl}api/v1/auth/oktatoken`
  }

  // end-point config of GPM Okta Token for D2C.
  oktaGPMAuthEndPoint() {
    return `${this._config.site.apiUrl}api/v1/auth/GPMOktaToken`
  }

  // end-point to get data from DeviceMakeModels in B2C or MS1.
  makesEndPoint() {
    return `${this._config.site.apiUrl}api/v1/Device/makes`
  }

  getEquipMentsURL() {
    return `${this._config.site.apiUrl}api/v1/Device/getAllEquipments`
  }

  // end-point to get Branch Code, Branch Name, Branch Address and other details for MS1.
  branchDetailsEndPoint() {
    return `${this._config.site.apiUrl}api/v1/profile/branchDetails`
  }

  clearAPIResourceCacheEndPoint() {
    return `${this._config.site.apiUrl}api/v1/resource/clearResourceCache`
  }

  // Part of AUL integration
  aulLoginEndpoint(): string {
    return `${this.aulUrl}/Public/${this.isSSOEnabled ? LoginType.SSO : LoginType.Login}/${this.aulClient}/${this.aulApplicationName}`;
  }

  // Part of AUL integration
  aulEditProfileEndpoint(email: string, redirectUrl: string) {
    return `${this.aulUrl}/board/editProfile/${encodeURIComponent(redirectUrl)}`
  }

  // Part of AUL integration
  aulLogOutEndpoint() {
    if (!!this.isSSOEnabled) {
      return this.aulLoginEndpoint();
    }
    return `${this.aulUrl}/Public/LogOut`
  }

  // Part of AUL integration
  aulAddProfileEndpoint(redirectUrl: string, queryString: any) {

    if (queryString != null) {
      return `${this.aulUrl}/profile/${encodeURIComponent(redirectUrl)}/${queryString}`
    }

    return `${this.aulUrl}/profile/${encodeURIComponent(redirectUrl)}`
  }

  // Part of AUL Integration
  get aulApiUrl() {
    return this._config.aul.aulApiUrl;
  }

  get isSSOEnabled(): boolean {
    const isAULFromStorage = localStorage.getItem("isAUL");
    if (!!isAULFromStorage) {
      return !JSON.parse(isAULFromStorage);
    }
    else {
      const isAul = this.route.snapshot.queryParamMap.get('isAUL');
      if (!!isAul) {
        try {
          localStorage.setItem("isAUL", isAul.toLowerCase());
          return !JSON.parse(isAul.toLowerCase());
        }
        catch (e) {
          return this.returnIsSSOEnabled();
        }
      }
      else {
        return this.returnIsSSOEnabled();
      }
    }
  }

  returnIsSSOEnabled(): boolean {
    if (!!this._config.aul && !!this._config.aul.isSSOEnabled) {
      try {
        return JSON.parse(this._config.aul.isSSOEnabled)
      }
      catch (e) {
        return false;
      }
    } else {
      return false;
    }
  }

  get oktaBaseUrl() {
    return this._config.oktaSettings.oktaBaseUrl;
  }
  get oktaClientId() {
    return this._config.oktaSettings.oktaClientId;
  }

  get oktaClientSecret() {
    return this._config.oktaSettings.oktaClientSecret;
  }

  get oktaInternalEndPoint() {
    return this._config.oktaSettings.oktaInternalEndPoint;
  }
  get oktkaIssuer() {
    return this._config.oktaSettings.oktkaIssuer;
  }

  get aulOktaPrefix() {
    return this._config.aulOktaPrefix;
  }

  get oktaPrefix() {
    return this._config.oktaSettings.oktaPrefix;
  }
  get oktaAuthIssuer() {
    return this._config.oktaSettings.oktaAuthIssuer;
  }
  get oktaAuthorizeUrl() {
    return this._config.oktaSettings.oktaAuthorizeUrl;
  }
  get mockDotnetApiUrl(): string {
    return this._config.dotnetApiUrl;
  }

  get ewayPublicApiKey(): string {
    return this._config.ewayConfig.publicApiKey
  }

  get appInsightsKey(): string {
    return this._config?.appInsights?.instrumentationKey
  }

  get startingPage(): string {
    return this._config.core.startingPage;
  }

  get getGPMPreferredCultureCode(): string {
    return this._config.gpmPaymentgatewaySettings.preferredCultureCode;
  }
  get getGPMsourceSystemProgramIdentifier(): string {
    return this._config.gpmPaymentgatewaySettings.sourceSystemProgramIdentifier;
  }
  get getGPMjSUrl(): string {
    return this._config.gpmPaymentgatewaySettings.jsUrl;
  }
  get getGPMcssUrl(): string {
    return this._config.gpmPaymentgatewaySettings.cssUrl;
  }
  get getPreconnectUrls(): string {
    return this._config.core.preconnectUrls;
  }
  get getDefaultRoute(): string {
    return this._config.core.defaultRoute;
  }
  get getPageRedirectPostLogin(): string {
    return this._config.aul.pageRedirectPostLogin;
  }
  get getEnableClientAULLogin(): string {
    return this._config.aul.enableClientAULLogin;
  }
   get getAPIRequestEncryptionKey(): string {
    return this._config.core.aPIRequestEncryptionKey;
  }
}
